import { type Dispatch, type SetStateAction, useEffect, useState } from 'react';

import { ScSpinnerSlots } from './styled';

interface SpinnerSlotsProps {
  slotMainImage: string;
  chunksImage: string;
  isAnimationStarted: boolean;
  isAnimationEnded: boolean;
  isAnimationIncluded: boolean;
  borderSlotColor: string;
  setIsAnimationEnded: Dispatch<SetStateAction<boolean>>;
}

interface SlotProps {
  index: number;
  isAnimationEnded: boolean;
}

const getRandomPosition = () => Math.floor(Math.random() * (3 - 0) + 0) * 128;

const lastSlotElementPositionX = getRandomPosition();
const lastSlotElementPositionY = getRandomPosition();

const setPositionForElements = (index: number) => {
  const posX = index === 1 ? lastSlotElementPositionX : getRandomPosition();
  const posY = index === 1 ? lastSlotElementPositionY : getRandomPosition();

  return `${posX}px ${posY}px`;
};

const Slot = ({ index, isAnimationEnded }: SlotProps) => {
  const [element, setElement] = useState('');

  useEffect(() => {
    setElement(setPositionForElements(index));
  }, [index]);

  return (
    <div
      className="slot"
      style={{
        backgroundPosition: element,
        animationName: `${isAnimationEnded && index === 1 && 'blink'}`,
      }}
    />
  );
};

export const SpinnerSlots = ({
  slotMainImage,
  chunksImage,
  isAnimationStarted,
  isAnimationEnded,
  isAnimationIncluded,
  borderSlotColor,
  setIsAnimationEnded,
}: SpinnerSlotsProps) => {
  const handleAnimationEnd = (index: number) => {
    if (index === 2) setIsAnimationEnded(true);
  };

  return (
    <ScSpinnerSlots
      borderSlotColor={borderSlotColor}
      chunksImage={chunksImage}
      className="slots-container"
      lastSlotElementPosition={-75}
      slotMainImage={slotMainImage}
    >
      {isAnimationIncluded && (
        <img
          alt="Fire"
          src="https://lu-img.s3.ap-southeast-2.amazonaws.com/lp/sun-of-egypt/fire.png"
        />
      )}
      {Array.from({ length: 3 }).map((_, index) => (
        <div className="slots__container" key={index}>
          <div className="slots__blur top" />
          <div
            className={'slots__wrapper'}
            onAnimationEnd={() => handleAnimationEnd(index)}
            style={{
              animationName: `${isAnimationStarted && 'spin'}`,
              animationDuration: `${(index + 1) * 3}s`,
            }}
          >
            {Array.from({ length: 49 }).map((_, index) => (
              <Slot
                index={index}
                isAnimationEnded={isAnimationEnded}
                key={index}
              />
            ))}
          </div>
          <div className="slots__blur bottom" />
        </div>
      ))}
      {isAnimationIncluded && (
        <img
          alt="Fire"
          src="https://lu-img.s3.ap-southeast-2.amazonaws.com/lp/sun-of-egypt/fire.png"
        />
      )}
    </ScSpinnerSlots>
  );
};
